/* file: brand/bundles.js -> assets/ef-bundles.js
 *
 * Setup bundles, buy more save more (owner, 03NOV2026; tools/bundles.py makes
 * the products). window.efBundles (header, until 31 Dec 2026 23:59 MYT) maps a
 * power station's variant id to its two bundles:
 *   { "<station variant>": [{ v, h, t, price, was, extra, add }, ...] }
 * price / was / extra are cents: extra is what the bundle saves over buying
 * the same items one by one WITH EF1111 (the honest comparison during 11.11).
 *
 * - Product pages of the four stations: a "Save more with a setup" block
 *   under the price, each bundle with its monthly figure (window.efPay), its
 *   one-off price and one Add to Cart.
 * - Cart drawer / cart page: [data-ef-swap] buttons rendered by
 *   snippets/ef-addons.liquid swap ONE station for its bundle.
 * Adds go through /cart/add.js and then 'ef:cart:added', so drawer.js opens
 * and re-renders the drawer the way it does for every other add.
 */
(function () {
  "use strict";
  var doc = document, B = window.efBundles, P = window.efPay;
  if (!B) return;
  var T = B.t || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function el(tag, cls, text) {
    var e = doc.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function rm(c) {
    var n = c / 100;
    return "RM " + n.toLocaleString("en-MY", n % 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : { maximumFractionDigits: 0 });
  }
  function rm2(c) {
    return "RM " + (c / 100).toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function post(path, body) {
    return fetch(root + path, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
                                body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function added() { doc.dispatchEvent(new CustomEvent("ef:cart:added")); }
  function busy(btn, on) { btn.disabled = on; btn.classList.toggle("is-busy", on); }

  /* ---- product page: choose your setup ------------------------------------ */
  /* Owner, 04NOV2026: "redesign the layout to be more intuitive ... thumbnail for the bundle product
     and even have recommended tag ... one page view all without scrolling too much". One tile per
     choice -- this unit, then each bundle holding it -- in a radio grid. Choosing a bundle points the
     page's own form at the bundle's variant and writes the bundle's cart price into the theme's
     [data-ef-price], so every price on the page (the monthly lead, the EF1111 line, the sticky bar's
     reader) repaints from one place; Add to cart then adds the bundle through drawer.js like any add.
     Shopify's Buy it now button cannot be re-pointed, so a bundle gets its own Buy now (add, then
     checkout). Recommended = the offer saving the largest share of its regular price. */
  function cents(text) {
    var x = /RM\s?([\d,]+(?:\.\d+)?)/.exec(text || "");
    return x ? Math.round(parseFloat(x[1].replace(/,/g, "")) * 100) : 0;
  }
  function themeMoney(c) {           /* the store's own format: "RM9,526.19 MYR" */
    var n = c / 100;
    return "RM" + n.toLocaleString("en-MY", n % 1 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : { maximumFractionDigits: 0 }) + " MYR";
  }
  function pdp() {
    var input = doc.querySelector('#ef-product-form [name="id"]') || doc.querySelector('form[action*="/cart/add"] [name="id"]');
    var line = doc.querySelector(".ef-priceline");
    var src = line && line.querySelector("[data-ef-price]");
    if (!input || !src) return;
    var form = input.form;
    var C = window.efCampaign, coded = C && Date.now() >= C.start && Date.now() <= C.end;
    var box = el("section", "efc");
    box.setAttribute("aria-label", T.choose);
    var head = el("div", "efc__head");
    head.appendChild(el("p", "efc__k", coded ? T.kSale : T.k));
    head.appendChild(el("h3", "efc__h", T.choose));
    box.appendChild(head);
    var grid = el("div", "efc__grid");
    grid.setAttribute("role", "radiogroup");
    grid.setAttribute("aria-label", T.choose);
    box.appendChild(grid);
    var sel = el("p", "efc__sel");
    box.appendChild(sel);
    box.appendChild(el("p", "efc__note", T.tileNote));
    var anchor = line;
    anchor.parentNode.insertBefore(box, anchor.nextSibling);

    var addBtn = form && form.querySelector("[type=submit]");
    var native = form && form.querySelector(".shopify-payment-button");
    var buy = el("button", "eft-btn efc__buy", T.buyNow);
    buy.type = "button"; buy.hidden = true;
    if (native) native.parentNode.insertBefore(buy, native);
    else if (addBtn) addBtn.parentNode.insertBefore(buy, addBtn.nextSibling);

    var base = null, picked = null;
    function charge(o) { return coded ? o.final : o.price; }
    function priceSpans(c, was) {
      var wrap = el("span", "efc__price");
      if (P && c >= P.min) {
        var mo = el("span", "efc__mo", rm2(Math.round(c / P.n)));
        mo.appendChild(el("span", "efc__per", P.t.per));
        wrap.appendChild(mo);
      }
      wrap.appendChild(el("span", "efc__full", rm2(c)));
      if (was && was > c) wrap.appendChild(el("s", "efc__was", rm(was)));
      return wrap;
    }
    function choose(o, tile) {
      Array.prototype.forEach.call(grid.children, function (t) { t.setAttribute("aria-checked", t === tile ? "true" : "false"); });
      picked = o;
      /* the sticky bar and the phone sheet print the price too: they follow the choice */
      var mirrors = doc.querySelectorAll("[data-ef-pbar-price], .eft-sheet__current-price");
      Array.prototype.forEach.call(mirrors, function (m) {
        if (m._efBase == null) m._efBase = m.textContent;
        m.textContent = o ? themeMoney(o.price) : m._efBase;
      });
      if (!o) {
        input.value = base.vid;
        src.textContent = base.text;
        sel.textContent = "";
      } else {
        input.value = o.v;
        src.textContent = themeMoney(o.price);
        sel.textContent = o.box && o.box.length ? T.box + ": " + o.box.join(" · ") : o.t;
      }
      buy.hidden = !o;
      if (native) native.hidden = !!o;
      box.classList.toggle("is-bundle", !!o);
    }
    function render() {
      var opts = B.map[String(input.value)];
      grid.textContent = "";
      box.hidden = !opts;
      if (!opts) return;
      base = { vid: String(input.value), text: src.textContent };
      Array.prototype.forEach.call(doc.querySelectorAll("[data-ef-pbar-price], .eft-sheet__current-price"), function (m) { m._efBase = null; });
      var unitC = cents(base.text), unitCharge = coded && C.exclude.indexOf(location.pathname.split("/products/")[1].split(/[?#/]/)[0]) < 0
        ? unitC - Math.round(unitC * C.pct / 100) : unitC;
      var frame = doc.querySelector(".eft-pdp__frame.is-current, .eft-pdp__frame, .eft-pdp__media img");
      var best = null, bestK = 0;
      opts.forEach(function (o) { var k = (o.was - charge(o)) / o.was; if (k > bestK) { bestK = k; best = o; } });
      var tiles = [{ unit: true, s: T.unit, img: frame && (frame.currentSrc || frame.src), c: unitCharge, was: coded ? unitC : 0 }]
        .concat(opts.map(function (o) { return { o: o, s: o.s || o.t, img: o.img, c: charge(o), was: o.was }; }));
      tiles.forEach(function (x, i) {
        var t = el("button", "efc__t" + (x.o && x.o === best ? " is-rec" : ""));
        t.type = "button";
        t.setAttribute("role", "radio");
        t.setAttribute("data-h", x.o ? x.o.h : decodeURIComponent(location.pathname.split("/products/")[1].split(/[?#/]/)[0]));
        t.setAttribute("aria-checked", i === 0 ? "true" : "false");
        var pic = el("span", "efc__img");
        if (x.img) { var im = el("img"); im.src = x.img + (x.img.indexOf("?") > 0 ? "&" : "?") + "width=160"; im.alt = ""; im.loading = "lazy"; pic.appendChild(im); }
        t.appendChild(pic);
        var txt = el("span", "efc__txt");
        txt.appendChild(el("span", "efc__name", x.s));
        txt.appendChild(priceSpans(x.c, x.was));
        if (x.was > x.c) txt.appendChild(el("span", "efc__save", T.save.replace("{x}", rm2(x.was - x.c))));
        t.appendChild(txt);
        if (x.o && x.o === best) t.appendChild(el("span", "efc__tag", T.rec));
        t.addEventListener("click", function () { choose(x.o || null, t); });
        grid.appendChild(t);
      });
      picked = null; buy.hidden = true; if (native) native.hidden = false; box.classList.remove("is-bundle");
      doc.dispatchEvent(new CustomEvent("ef:tiles"));
    }
    buy.addEventListener("click", function () {
      if (!picked) return;
      busy(buy, true);
      post("cart/add.js", { id: picked.v, quantity: 1 })
        .then(function () { location.href = root + "checkout"; })
        .catch(function () { buy.textContent = T.fail; busy(buy, false); });
    });
    render();
    /* another model picked in the theme's own picker: the theme rewrites the id and the price, and
       the tiles start again from that variant (our own writes are told apart by `picked`) */
    if (form) form.addEventListener("change", function () { setTimeout(render, 0); });
    new MutationObserver(function () {
      if (!picked && base && String(input.value) !== base.vid) render();
    }).observe(src, { childList: true, characterData: true, subtree: true });
  }

  /* ---- cart: swap one station for its bundle ------------------------------ */
  doc.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-ef-swap]");
    if (!b) return;
    e.preventDefault();
    var key = b.getAttribute("data-ef-swap"), qty = parseInt(b.getAttribute("data-qty"), 10) || 1;
    var v = parseInt(b.getAttribute("data-variant"), 10);
    busy(b, true);
    post("cart/change.js", { id: key, quantity: qty - 1 })
      .then(function () { return post("cart/add.js", { id: v, quantity: 1 }); })
      .then(function () {
        if (b.hasAttribute("data-page")) { location.reload(); return; }
        added();
      })
      .catch(function () { b.textContent = T.fail; busy(b, false); });
  });

  if (/\/products\//.test(location.pathname)) pdp();
})();
